<template>
  <div class="flex flex-row justify-center  items-center h-screen">

       <div class="flex flex-row  shadow container_wh">
         <div class="flex flex-col items-center justify-center h-full left_w">
             <div>

              <div>
                  <p class="text-3xl">你好</p>
                  <p class="text-3xl mt-5">欢迎使用会员系统</p>
              </div>
              <div class="mt-14 w-72">

                  <div class="border rounded h-12 flex items-center" :style="inputIdx==0?'outline: 2px solid #10B981;':'outline: 2px solid transparent;'">
                        <i class="iconfont icon-account-circle  px-3 color_01 font_size_pt_18" ></i>
                        <div class="border-l h-12 flex items-center" >
                               <input type="text" placeholder="请输入账号"  class="focus:outline-none outline-none h-10 pl-3 inputEle" maxlength="10" v-model.lazy.trim="account" @click="changeIdx(0)" @keyup.enter="gotoNext(1)" v-focus />
                        </div>

                  </div>

                   <div class="border rounded h-12  mt-6 flex items-center" :style="inputIdx==1?'outline: 2px solid #10B981;':'outline: 2px solid transparent;'">
                        <i class="iconfont icon-vpn-key px-3 color_01 font_size_pt_18"></i>
                          <div class="border-l h-12 flex items-center">
                        <input  type="password" placeholder="请输入密码"  class="focus:outline-none outline-none h-10 pl-3 inputEle" maxlength="10" v-model.lazy.trim="pwd" @click="changeIdx(1)" @keyup.enter="gotoNext(2)"/>
                        </div>
                  </div>
                  <div class="mt-10">
                        <button  class="bg-green-500 active:bg-green-700 h-12  w-72 rounded text-white inputEle"  @click="changeIdx(2),doLogin()">登&nbsp;&nbsp;录</button>
                  </div>

              </div>

             </div>

         </div>
         <div class="right_w">
              <div class=" mt-32 ml-16">

              <div class=" mb-5">
                   <el-button   color="#10B981" plain class="num_btn"  round @click="clickNum(1)" >1</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(2)" >2</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(3)" >3</el-button>
              </div>
              <div  class=" mb-5">
                   <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(4)" >4</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(5)" >5</el-button>
                     <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(6)" >6</el-button>
              </div>
              <div  class=" mb-5">
                   <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(7)" >7</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(8)" >8</el-button>
                     <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(9)" >9</el-button>
              </div>
              <div  class=" mb-5">
                   <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(0)" >0</el-button>
                   <el-button type="warning" plain class="num_btn_big"  round  @click="clickNum('C')" >C</el-button>
              </div>

              </div>
         </div>

   </div>

  </div>

</template>
<script>
import { ref } from '@vue/reactivity'
import { ElNotification, ElLoading, ElMessage } from 'element-plus'
import { localSet, getUrlKey } from '@/utils/index'
import axios from '@/utils/axios'
import { useStore } from 'vuex'

import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  setup () {
    const store = useStore()

    const inputIdx = ref(0)
    const account = ref('')
    const pwd = ref('')
    const gotoNext = (idx) => {
      inputIdx.value = idx
      document.getElementsByClassName('inputEle')[idx].focus()
    }
    const changeIdx = (idx) => {
      inputIdx.value = idx
    }
    const doLogin = () => {
      if (account.value.trim().length == 0) {
        ElNotification({
          title: '错误',
          message: '请输入登录账号',
          type: 'error',
          position: 'top-left'
        })
        return
      }
      if (pwd.value.trim().length == 0) {
        ElNotification({
          title: '错误',
          message: '请输入登录密码',
          type: 'error',
          position: 'top-left'
        })
        return
      }

      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios.post('/pos_cashier/login', {
        account: account.value,
        pwd: pwd.value,
        terminal_code
      }).then(res => {
        localSet('token', res)

        store.commit('initUser', res)

        window.location.href = '/'
      })
        .finally(() => {
          loading.close()
        })
    }
    const clickNum = (num) => {
      if (num == 'C') {
        if (inputIdx.value == 0) {
          account.value = ''
        } else if (inputIdx.value == 1) {
          pwd.value = ''
        }
      } else {
        if (inputIdx.value == 0) {
          if (account.value.length > 20) {
            return
          }
          account.value += num
        } else if (inputIdx.value == 1) {
          if (pwd.value.length > 20) {
            return
          }
          pwd.value += num
        }
      }
    }

    let terminal_code = ''
    //        (async () => {
    //   const fp = await FingerprintJS.load();

    //   const result =await fp.get();

    //   terminal_code = result.visitorId;
    //    localSet("terminal_code",terminal_code);
    // })();

    terminal_code = getUrlKey('key')
    return {
      account, pwd, inputIdx, gotoNext, clickNum, changeIdx, doLogin
    }
  }
}
</script>
<style scoped>
.container_wh{
width:867px;
height:530px;
}
.left_w{
      width:417px;
      height:530px;
}
.right_w{
width:450px;
height:530px;
}
.num_btn{
      width:100px;
      font-size:20px;
}
.num_btn_big{
       width:210px;
      font-size:20px;
}

</style>
